import React from 'react';
import { useNavigate, useLocation } from 'react-router';
import { observer } from 'mobx-react-lite';
import { OutlineArrowRight } from '@producer/ui-kit';

import { ProducerLogo } from '../../components/icons/producer-logo';
import { UserDropdown } from './components/user-dropdown';
import { BackButton } from '../../features/settings/components/settings-page-layout';
import { Space } from '../../app/entities/space';

import styles from './on-boarding.layout.module.scss';
export const OnBoardingLayout: React.FC<React.PropsWithChildren> = observer(({ children }) => {
  const spaces = Space.getAll();
  const hasSpaces = spaces.length;

  const navigate = useNavigate();
  const location = useLocation() as { state: { spaceId: string } };

  const goBack = () => {
    const spaceId = location?.state?.spaceId;
    const href = spaceId ? `/space/${spaceId}` : `/`;

    navigate(href);
  };

  return (
    <div className={styles['page']}>
      <div className={styles['page-header']}>
        <UserDropdown />

        {hasSpaces !== 0 && (
          <BackButton onClick={goBack}>
            <OutlineArrowRight />
            <span>Back to PRODUCER</span>
          </BackButton>
        )}
      </div>

      <div className={styles['container']}>
        <ProducerLogo />

        <div className={styles['content']}>{children}</div>
      </div>
    </div>
  );
});
